export enum CreditCardDetailsCompletionStatus {
  NotStarted = 0,
  InProgress = 1,
  Succeeded = 2,
  Error = 3,
}
